// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"43":"896086d8","311":"7aa51463","331":"32a3ba56","413":"445d6813","842":"f985c435","941":"91118672"}[chunkId] + ".css";
};